import { Component } from '@angular/core';

@Component({
  selector: 'pc-project-circles',
  standalone: true,
  imports: [],
  templateUrl: './project-circles.component.html',
  styleUrl: './project-circles.component.scss'
})
export class ProjectCirclesComponent {

}
